<template>
  <div class="mall-month-data">
    <div class="filter">
      <el-tooltip
        effect="dark"
        placement="top">
        <div slot="content">
          更多
        </div>
        <el-checkbox-group v-model="checkList">
          <el-dropdown
            :hide-on-click="false"
            trigger="click"
            @visible-change="(visible) => dropdownVisible = visible ">
            <span
              :class="{ visible: dropdownVisible }"
              class="dropdown-link">
              <i class="eqf-menu-p"></i>
            </span>
            <el-dropdown-menu
              slot="dropdown"
              class="more-dropdown">
              <el-dropdown-item
                v-for="item in panelEnum"
                :key="item.key">
                <el-checkbox
                  :label="item.key"
                  style="width: 84px">{{ item.name }}</el-checkbox>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-checkbox-group>
      </el-tooltip>
    </div>
    <el-row
      :gutter="24"
      class="panel-list">
      <el-col
        v-for="(item, index) in filterPanelList"
        :span="colSpan"
        :key="item.key"
        :class="['panel-list__col' + colSpan]"
        class="panel-list__col">
        <div class="panel-list__item">
          <div
            class="panel-fullscreen"
            @click="openDetail(index)">
            <el-tooltip
              effect="dark"
              placement="top">
              <div slot="content">
                全屏
              </div>
              <svg-icon
                icon-class="fullscreen_open"
                class-name="fullscreen-icon" />
            </el-tooltip>
          </div>
          <div class="panel-header">
            <span class="panel-title">{{ item.name }}</span>
            <span class="panel-level">{{ item.showkerRank || 0 }}级</span>
            <span class="panel-tips">
              新增模板量：<span class="num">{{ item.showkerAddTemplate || 0 }}</span>个；
              其中免费：<span class="num">{{ item.showkerFreeTemplate || 0 }}</span>个
            </span>
          </div>
          <div class="panel-body">
            <MallMonthDataChart
              v-if="showChart"
              :data="getChartData(item)" />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getNewIncome } from 'src/api/showker'
import MallMonthDataChart from './MallMonthDataChart'
import MallMonthDataDetail from './MallMonthDataDetail'

const panelEnum = [
  {
    key: 'h5',
    name: 'H5'
  },
  {
    key: 'h2',
    name: '海报'
  },
  {
    key: 'h5l',
    name: '长页'
  },
  {
    key: 'video',
    name: '视频'
  },
  {
    key: 'gc',
    name: '互动'
  },
  {
    key: 'h5e',
    name: '表单'
  }
]

export default {
  name: 'MallMonthData',
  components: {
    MallMonthDataChart
  },
  data() {
    return {
      checkList: ['h5', 'h2', 'h5l', 'video', 'gc', 'h5e'],
      panelEnum,
      panelList: [...panelEnum],
      colSpan: 12,
      showChart: false,
      dropdownVisible: false
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    filterPanelList() {
      return this.panelList.filter(item => this.checkList.includes(item.key))
    }
  },

  created() {
    this.getData()
  },
  mounted() {
    this.setColSpan()
    window.addEventListener('resize', () => {
      this.setColSpan()
    })
  },
  methods: {
    setColSpan() {
      this.showChart = false
      const width = document.body.clientWidth
      if (width > 1600) {
        this.colSpan = 8
      } else {
        this.colSpan = 12
      }
      this.$nextTick(() => {
        this.showChart = true
      })
    },
    async getData() {
      try {
        const { data } = await getNewIncome({
          showkerId: this.userInfo.id
        })
        if (data && data.obj) {
          const keyEnum = {
            h5: 'h5data',
            h2: 'designdata',
            h5l: 'longdata',
            video: 'videodata',
            gc: 'gcdata',
            h5e: 'formdata'
          }
          this.panelList = this.panelList.map(item => {
            const key = keyEnum[item.key]
            const obj = data.obj[key]

            return {
              ...item,
              ...obj
            }
          })
        }
      } catch (e) {
        throw e
      }
    },
    getChartData(item) {
      if (['gc'].includes(item.key)) {
        return [
          {
            label: '互动收益',
            value: +(item.showkerInteractIncome / 100).toFixed(2)
          }
        ]
      }
      if (['h5e'].includes(item.key)) {
        return [
          {
            label: '表单收益',
            value: +(item.showkerFromIncome / 100).toFixed(2)
          }
        ]
      }

      return [
        {
          label: '会员收益',
          value: +(item.showkerVipIncome / 100).toFixed(2)
        },
        {
          label: '订单收益',
          value: item.showkerOrderIncome
        }
      ]
    },
    openDetail(index) {
      this.dialog.open({
        component: MallMonthDataDetail,
        data: {
          list: this.filterPanelList,
          index,
          showkerId: this.userInfo.id
        },
        listeners: {}
      })
    }
  }
}
</script>

<style lang="scss">
.more-dropdown.el-dropdown-menu {
  // ui标准化后删除
  border: none;
  box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03), 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  &.el-popper[x-placement^="bottom"] {
    margin-top: 4px;
  }
  .popper__arrow {
    display: none;
  }
  .el-dropdown-menu__item {
    padding: 0 12px;
  }
}
</style>

<style lang="scss" scoped>
    .mall-month-data {
        position: relative;

        .filter {
            position: absolute;
            top: -38px;
            right: 0;

            .dropdown-link {
              &.visible {
                .eqf-menu-p {
                  display: inline-block;
                  width: 24px;
                  height: 24px;
                  border-radius: 4px;
                  background-color: #E7EFFF;
                  color: #1261FF;
                }
              }
            }

            .eqf-menu-p {
              display: inline-block;
              width: 24px;
              height: 24px;
              font-size: 24px;
              color: #000;
              cursor: pointer;

              &:hover {
                  color: #1261FF;
              }
            }
        }

        .panel-list {
            &__col12 {
                &:not(:nth-child(-n+2)) {
                    margin-top: 24px;
                }
            }

            &__col8 {
                &:not(:nth-child(-n+3)) {
                    margin-top: 24px;
                }
            }
            &__item {
                width: 100%;
                height: 270px;
                border: 1px solid #E6EBED;
                border-radius: 4px;
                display: flex;
                flex-direction: column;
                position: relative;
                transition: all .3s;

                &:hover {
                  border-color: transparent;
                  box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03), 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.08);
                }

                .panel-fullscreen {
                    position: absolute;
                    top: 6px;
                    right: 6px;
                    cursor: pointer;

                    .fullscreen-icon {
                      font-size: 28px;
                      color: #999;

                      &:hover {
                        color: #1261FF;
                      }
                    }
                }

                .panel-header {
                    line-height: 16px;
                    margin-bottom: 12px;
                    padding: 28px 28px 0 28px;
                    display: flex;

                    .panel-title {
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;
                    }

                    .panel-level {
                      display: inline-block;
                      height: 16px;
                      line-height: 12px;
                      text-align: center;
                      padding: 1px 4px;
                      margin-left: 8px;
                      font-size: 12px;
                      color: #999;
                      border-radius: 4px;
                      border: 1px solid #BFBFBF;
                    }

                    .panel-tips {
                        margin-left: 20px;
                        font-size: 14px;
                        color: #999;

                        .num {
                          color: #1261FF;
                        }
                    }
                }

                .panel-body {
                    flex: 1;
                }
            }
        }
    }
</style>
